import { regex } from './common'
export default regex('tin', /^[a-zA-Z0-9&-]{7,20}$/)